// extracted by mini-css-extract-plugin
export default {"cart_container":"cartTab_cart_container__Wxdbh","list_wrap":"cartTab_list_wrap__DkY4r","total_wrap":"cartTab_total_wrap__T6jIh","modal_body":"cartTab_modal_body__ZP7-v"};